export default __webpack_public_path__ + "static/media/Truspilot-3.c58ddcba.png";